import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-purchase-requisition-software',
  imports: [RouterModule, FeatureHero],
  templateUrl: './purchase-requisition-software.html',
  styleUrl: './purchase-requisition-software.scss',
})
export class PurchaseRequisitionSoftware {

}
